/* hs-eslint ignored failing-rules */

/* eslint-disable no-bitwise */
'use es6';

import PropTypes from 'prop-types';
import ReactUtilsPropTypes from 'react-utils/CustomPropTypes';
/**
 * @typedef {Object} LineRange
 * @property {UInt32} from - Starting line number. Required.
 * @property {UInt32} to   - Ending line number.
 */

function validateRangeField(field, value) {
  if (value !== value >>> 0) {
    throw new TypeError(`LineRange#${field} is required and must be a uint. Received ${field}: ${value}`);
  }
}
/**
 * Model a range of code file lines.
 */


export default class LineRange {
  /**
   * @param  {UInt32} options.from
   * @param  {UInt32} options.to
   * @return {LineRange}
   */
  constructor({
    from,
    to
  }) {
    validateRangeField('from', from);
    this.from = from;
    this.to = to;
    Object.freeze(this);
  }

}
/**
 * @type {Function}
 */

LineRange.shapePropType = PropTypes.shape({
  from: ReactUtilsPropTypes.uint32.isRequired,
  to: ReactUtilsPropTypes.uint32
});
/**
 * @type {Function}
 */

LineRange.lineRangesPropType = PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.instanceOf(LineRange), LineRange.shapePropType]));